import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import { MapModules } from './MapModules';


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // все точки на карте
        points: null,
        // количество загружаемых точек для района
        pointCount: 100,
        // районы (границы и фильтр)
        regions: {
            // границы районов
            borders: {
                style: {
                    default: {
                        fillColor: 'rgba(191, 191, 191, 0.5)',
                    },
                    selected: {
                        fillColor: 'rgba(255, 200, 44, 0.5)',
                    }
                },
            },
            // фильтр районов
            filter: [],
            selectMap: null,
            // карта терминов
            termMap: null,
            // выбрано слов
            termsFilteredCount: 0
        },
        // термины
        terms: {
            // список для фильтра
            filter: [],
            // максимальное количество слов для отображения
            termsLimit: 100,
            // карта регионов
            regMap: null,
            // последний добавленный номер для окрашивания точки в другой цвет
            lastId: 0,
            // тип поиска 0 - по словам, 1 - по определениям
            searchType: false,
            // поле поиска термина
            search: '',
            // поле поиска описания
            searchDescription: '',
            // результаты поиска по описанию
            searchDescriptionResults: [],
            termstack: []
        },
        // категории
        categories: {
            // список для фильтра
            filter: [],
            // карта терминов
            termMap: null,
            // выбрано слов
            termsFilteredCount: 0
        },
        // Таймер обновления точек
        termWatching: 0,
        // всплывающее сообщение
        notify: {
            show: false,
            title: '',
            content: ''
          }
    },
    getters: {
        getNotify(state) {
            return state.notify
        },
        getSearch(state) {
            return state.terms.search
        },
        getSearchDescription(state) {
            return state.terms.searchDescription
        },
        getSearchType(state) {
            return state.terms.searchType
        },
        getSearchResults(state, getters) {
            return getters.termfilter.filter(term =>
                term.name.includes(state.terms.search.toUpperCase())
              );
        },
        getDescriptionSearchResults(state, getters) {
            return getters.termfilter.filter(term => state.terms.searchDescriptionResults.includes(term.id));
        },
        getSelectedResults(state) {
            var terms = state.terms.filter.filter(term => term.selected);
            if (terms) return terms
            return []
        },
        termfilter(state) {
            state.terms.lastId = 0
            if (state.regions.filter.length + state.categories.filter.length == 0) return []

            state.terms.termsLimit = 100

            // фильтр по районам
            var termLocFilter = new Set()
            state.regions.selectMap = new Map()
            var regMap = state.regions.termMap
            state.regions.filter.forEach(reg => {
                state.regions.selectMap.set(reg.id, reg.selected)
                if(reg.selected && regMap.has(reg.id)) {
                    regMap.get(reg.id).forEach(el => {
                        termLocFilter.add(el)
                    })
                }
            })
            // фильтр по категориям
            var termCatFilter = new Set()
            var catMap = state.categories.termMap
            state.categories.filter.forEach(cat =>{
                if(cat.selected && catMap.has(cat.id)) {
                    catMap.get(cat.id).forEach(el => {
                        termCatFilter.add(el)
                    })
                }
            })
            // Пересчет информеров
            state.regions.termsFilteredCount = termLocFilter.size
            state.categories.termsFilteredCount = termCatFilter.size

            return state.terms.filter.filter(term => (termLocFilter.has(term.id) && termCatFilter.has(term.id)))
        }
    },
    mutations: { // Commit
        doNothing(){},
        // удаляет элемент из списка отложенных терминов
        delTermFromTermsstack(state, term) {
            var index = state.terms.termstack.findIndex(t => t.id == term.id)
            if (index >= 0) state.terms.termstack.splice(index, 1);
        },
        addTermToTermsstack(state, term) {
            state.terms.termstack.unshift(term);
        },
        delAllTermsFromTermsstack(state) {
            state.terms.termstack = [];
        },
        // сохранение описания слова для дальнейшего использования
        setTermDescription(state, {id, description}) {
            var term = state.terms.filter.find(term => term.id == id)
            if (term) term.description = description
        },
        // изменение строки поиска
        setSearch(state, data) {
            state.terms.search = data.search
        },
        setSearchDescription(state, data) {
            state.terms.searchDescription = data.search
        },
        setSearchType(state, data) {
            state.terms.searchType = data.searchType
        },
        clearSearchDescriptionResults(state) {
            state.terms.searchDescriptionResults = []
        },
        // добавление синонимов к термину
        addSyn(state, {data, getters}) {
            var terms = getters.termfilter
            data.forEach(termSyn => {
                var term = terms.find(el => (el.id == termSyn.id))
                if (term) {
                    var synIds = new Set(termSyn.synonyms)
                    term.syn = state.terms.filter.filter(term => (synIds.has(term.id)))
                }
            })
        },
        // событие смены фильтра районов по клику на карте
        regSelectionChange(state, e) {
            var reg = state.regions.filter.find(r => r.id == e.get('objectId'))
            if (reg) {
                var option = (reg.selected)?'default':'selected'
                window.borderManager.objects.setObjectOptions(reg.id, Object.assign({}, state.regions.borders.style[option]))
                reg.selected = !reg.selected
                if (document.getElementById('reglist')) {
                    let list = document.getElementById('reglist');
                    let item = document.getElementById('reg_' + reg.id);
                    list.scrollTop += item.getBoundingClientRect().y - 180;
                }
            }
        },
        addPoint(state, data) {
            var point = JSON.parse(data.location.replace('(', '[').replace(')', ']'))
            var content = {
                id: data.id,
                oktmo: data.oktmo,
                point,
                type: data.type,
            }
            if (state.points.has(data.oktmo))
                state.points.get(data.oktmo).push(content)
            else state.points.set(data.oktmo, [content])
            point = content = null
        },
        addTerm(state, data) {
            state.terms.filter.push({
                id: data.id,
                name: data.term,
                syn: [],
                synShow: false,
                selected: false,
                description: ""
            })
        },
        addCategory(state, data) {
            var level = data.rel.length
            state.categories.filter.push({
                id: data.id,
                name: data.caption,
                childs: [],
                level,
                parent: (level <= 1)?null:((level == 2)?data.rel[0]:data.rel[level - 2]),
                selected: false,
            })
        },
        setCatChilds(state) {
            var cats = state.categories.filter
            cats.forEach(cat => {
                if (cat.parent != null) cats[cat.parent].childs.push(cat)
            })
        },
        addTermLoc(state, data) {
            var map = state.regions.termMap
            if (map.has(data.location)) {
                map.get(data.location).push(data.term)
            } else map.set(data.location, [data.term])
        },
        addLocTerm(state, data) {
            var map = state.terms.regMap
            if (map.has(data.term)) {
                map.get(data.term).push(data.location)
            } else map.set(data.term, [data.location])
        },
        addTermCat(state, data) {
            var map = state.categories.termMap
            if (map.has(data.category)) {
                map.get(data.category).push(data.term)
            } else map.set(data.category, [data.term])
        },
        addRegion(state, data) {
            state.regions.filter.push({
                label: data.caption, 
                id: data.oktmo, 
                selected: false
            })
        }
    },
    actions: {
        // вывод отфильтрованных точек на карту
        async rePrintPoints({ state, getters, dispatch }) {
            // Защита от повторного выполнения
            if (state.termWatching < Date.now() - 100) {
                state.termWatching = Date.now()
    
                // отфильтрованные слова
                var terms = getters.termfilter
                // точки
                var points = state.points
                // счетчики количества связанных точек
                var counters = new Map()
                // максимальное количество точек по районам
                var limits = new Map()
                // карта слов с районами
                var locTerms = state.terms.regMap
                // карта выделенных районов
                var selectedRegions = state.regions.selectMap
                // итоговый массив точек
                var pointlist = []
    
                // задание начальных значений счетчика точек в районах перед перебором
                selectedRegions.forEach((_, reg) => {
                    counters.set(reg, 1)
                    limits.set(reg, points.get(reg).length)
                })
    
                // идем по всем отфильтрованным словам
                terms.forEach(term => {
                    // если слово выбрано
                    if (term.selected){
                        // получаем районы, в которых слово встречается
                        var regs = locTerms.get(term.id)
                        // ... и перебираем их
                        regs.forEach(reg => {
                            // если район выбран в фильтре
                            if(selectedRegions.get(reg)){
                                // выбираем номер точки этого района, с которой нужно связать слово
                                var id = (counters.get(reg) < limits.get(reg)) ? counters.get(reg) : 0
                                // заполняем массив для карты
                                pointlist.push({
                                    id: term.id,
                                    name: term.name,
                                    oktmo: reg,
                                    point: points.get(reg)[id].point,
                                    // Флаг Недавняя точка (перекрасить)
                                    lastPoint: state.terms.lastId == term.id
                                })
                                // считаем, что точка добавлена
                                counters.set(reg, counters.get(reg) + 1)
                            }
                        })
                    }
                })
    
                // конвертируем массив добавляемых точек в JSON
                var json = MapModules.GeoJSONFactory(pointlist,'points')
                
                // Выводим точки на карту
                MapModules.PointsPrint(json, (geoObjects, id, isCluster) => {
                    // Функция загрузки содержимого балуна точки
                    // закроем окно оповещения, у нас будет балун
                    state.notify.show = false;
                    // Создадим массив точек, для которых данные ещё не загружены.
                    var points = geoObjects.filter(geoObject => 
                        geoObject.properties.balloonContent === '...' ||
                        geoObject.properties.balloonContent === 'ошибка загрузки данных'
                    )
                    // Формируем массив идентификаторов, который будет передан серверу.
                    var ids = points.map(geoObject => geoObject.id)
                    // если массив не пустой
                    if (ids.length) {
                        // передаем его на сервер
                        dispatch('getTermsData', ids)
                            .then(data => {
                                    // заполняем данные точек согласно принятым ID
                                    geoObjects.forEach(geoObject => {
                                        geoObject.properties.balloonContentHeader = geoObject.properties.clusterCaption;
                                        geoObject.properties.balloonContentBody = data.find(el => el.id == geoObject.id).content.replaceAll(`<\\em>`, '</em>');
                                        geoObject.properties.balloonContentFooter = state.regions.filter.find(reg => geoObject.id.split("_")[0] == reg.id).label;
                                    })
                                    // Обновляем карту
                                    MapModules.setNewData(id, isCluster)
                                }
                            )
                            .catch(() => {
                                    // если не получилось принять данные, пишем стандартный текст
                                    geoObjects.forEach(geoObject => {
                                        geoObject.properties.balloonContent = 'ошибка загрузки данных!!!';
                                    })
                                    // Обновляем карту
                                    MapModules.setNewData(id, isCluster)
                                }
                            )
                    }
                })
                counters = limits = pointlist = json = null
            }
        },
        // Загрузка районов и точек
        async BordersLoader({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/regions/`)
                .then(response => {
                    state.points = new Map()
                    response.data.forEach( region => {
                        // формирование фильтра по районам
                        commit('addRegion', region)
                        // сохранение центров районов
                        commit('addPoint', {
                            id: region.oktmo + '_0', 
                            location: region.location, 
                            oktmo: region.oktmo, 
                            type: 'center'
                        })
                    })
                    resolve(response.data)
                }).catch(() => reject())
            })
        },
        // Загрузка фиктивных точек
        async PointsLoader({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/geopoints/?count=${state.pointCount}`)
                .then(response => {
                    response.data.forEach( data => {
                        // сохранение точек
                        commit('addPoint', {
                            id: data.oktmo + '_' + data.id, 
                            location: data.geopoint, 
                            oktmo: data.oktmo, 
                            type: 'fict'
                        })

                    })
                    resolve()
                }).catch(() => reject())
            })
        },
        // Загрузка балуна термина
        async getTermsData({ commit }, ids) {
            commit('doNothing')
            return new Promise((resolve, reject) => {
                axios.post(`${window.path}lang/api/terminfo/`, {ids})
                    .then(response => {resolve(response.data)})
                    .catch(() => reject())
            })
        },
        // Загрузка синонимов термина
        async getSynonyms({ commit, getters }, ids) {
            commit('doNothing')
            return new Promise((resolve, reject) => {
                axios.post(`${window.path}lang/api/synonyms/`, {"ids": ids})
                    .then(response => {
                        var data = response.data
                        commit('addSyn', {data, getters})
                        resolve(response.data)
                    })
                    .catch(() => reject())
            })
        },
        // Загрузка описания термина
        async getTermDesc({ state, commit }, id) {
            return new Promise((resolve, reject) => {
                var term = state.terms.filter.find(term=>term.id == id)
                if (term?.description) resolve(term.description)
                else axios.get(`${window.path}lang/api/terminfo/?id=${id}`)
                    .then(response => {
                        var rex = /(<([^>]+)>)/gi;
                        var description = response.data.replace(rex, "")
                        commit('setTermDescription', {id, description})
                        resolve(description)
                    })
                    .catch(() => reject())
            })
        },
        // Загрузка терминов
        async TermsLoader({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/terms/`)
                .then(response => {
                    response.data.forEach( data => {
                        // сохранение терминов
                        commit('addTerm', data)
                    })
                    resolve()
                }).catch(() => reject())
            })
        },
        // Загрузка категорий
        async CatsLoader({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/categories/`)
                .then(response => {
                    response.data.forEach( data => {
                        // сохранение категорий
                        commit('addCategory', data)
                    })
                    commit('setCatChilds')
                    resolve()
                }).catch(() => reject())
            })
        },
        // Загрузка связей терминов с регионами
        async TermsLocLoader({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/termlocs/`)
                .then(response => {
                    state.regions.termMap = new Map()
                    state.terms.regMap = new Map()
                    response.data.forEach(el => {
                        commit('addTermLoc', el)
                        commit('addLocTerm', el)
                    })
                    resolve()
                }).catch(() => reject())
            })
        },
        // Загрузка связей терминов с категориями
        async TermsCatLoader({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/termcats/`)
                .then(response => {
                    state.categories.termMap = new Map()
                    response.data.forEach(el => {
                        commit('addTermCat', el)
                    })
                    resolve()
                }).catch(() => reject())
            })
        },
        // поиск по описаниям терминов
        async SearchingInTermDescriptions({state}, q) {
            return new Promise((resolve, reject) => {
                axios.get(`${window.path}lang/api/search/?q=${q}`)
                .then(response => {
                    var ids = []
                    response.data.forEach(res => {
                        ids.push(res.term)
                        var term = state.terms.filter.find(term => term.id == res.term)
                        if(term) term.description = res.description
                    })
                    state.terms.searchDescriptionResults = ids
                    resolve()
                }).catch(() => reject())
              })
        },
        // Отправка сообщения через форму обратной связи
        async sendmail({commit}, data) {
            commit('doNothing')
            return new Promise((resolve, reject) => {
                axios.post(`${window.path}common/api/sendmail/`, data)
                .then(response => {
                    resolve(response)
                }).catch(() => reject())
              })
        }
    }
})
